import React from "react";
import { useAuthentication } from "scenes/useAuthentication";

const withAuth =
  (higherProps: { route: string }) => (WrappedComponent) => (props) => {
    const [userInfo, logout, userDetails, featureFlags] = useAuthentication({
      route: higherProps.route,
    });

    return (
      <WrappedComponent
        {...props}
        userInfo={userInfo}
        logout={logout}
        userDetails={userDetails}
        featureFlags={featureFlags}
      />
    );
  };

export default withAuth;
